import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pigmy-creation',
  templateUrl: './pigmy-creation.component.html',
  styleUrls: ['./pigmy-creation.component.css']
})
export class PigmyCreationComponent implements OnInit {
  title = "Pigmy Creation";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/pigmy-creation/pigmy-creation.component.ts